<ng-container *ngFor="let column of rowDisplayColumns">
  @if(tableService.getHeaderCell(column); as headerCell){
  <ng-container *ngTemplateOutlet="headerCell.templateRef"></ng-container>
  }
</ng-container>
